<script lang="ts">
  import clsx from 'clsx';
  import Play from '@athena-lib/Icons/Play.svelte';
  import { onMount } from 'svelte';
  import type { VideoProps } from './types';

  const {
    src,
    alt,
    class: className,
    preload,
    poster,
    autoplay,
    controls,
    loop,
    muted,
  }: VideoProps = $props();

  let isPlaying = $state(autoplay);
  let video: HTMLVideoElement | undefined = $state();

  onMount(() => {
    // Webkit browsers sometimes won't display poster until metadata is fetched
    if (isIOSWebKit() || isSafari()) {
      video?.load();
    }
  });

  const togglePlay = () => {
    if (autoplay) {
      return;
    }
    if (isPlaying) {
      video?.pause();
    } else {
      video?.play();
    }

    isPlaying = !isPlaying;
  };

  function isIOSWebKit() {
    const ua = navigator.userAgent;
    return /iP(hone|od|ad)/.test(ua) && /WebKit/i.test(ua) && !/Edge|OPiOS/.test(ua);
  }

  function isSafari() {
    const ua = navigator.userAgent;
    return /^((?!chrome|android).)*safari/i.test(ua);
  }
</script>

<div class="relative mx-auto w-full">
  <button type="button" onclick={togglePlay} disabled={autoplay} aria-label={alt} class="w-full">
    <video
      bind:this={video}
      class={clsx(className)}
      preload={preload ?? 'metadata'}
      {controls}
      {autoplay}
      {loop}
      {poster}
      {muted}
      {src}
      playsinline
    >
      Your browser does not support the video tag.
    </video>
    {#if !isPlaying}
      <div
        class="absolute inset-0 flex items-center justify-center text-st-white opacity-50 hover:opacity-100"
      >
        <Play sizeClass="w-20 h-20"></Play>
      </div>
    {/if}
  </button>
</div>
